import React from "react";
import UgcContainer from "./styles/Ugc.styles";
import HowItWorksBg from "../../../../images/how-it-works-bg.jpg";
import RightArrow from "../../../../images/right-arrow.svg";

export const HowItWorksSection = ({ title, description, line }) => (
  <div className="list">
    <div className="list-item">
      <div className="list-column">
        <div className="arrow-container">
          <img className="arrow-icon" alt="arrow-icon" src={RightArrow}></img>
        </div>
        {line && <div className="line"></div>}
      </div>
    </div>

    <div className="how-it-works-box">
      <h4 className="how-it-works-title">{title}</h4>
      <p className="how-it-works-description">{description}</p>
    </div>
  </div>
);

function Ugc() {
  return (
    <UgcContainer>
      <div className="ugc-wrapper">
        <h5 className="ugc-label">VIDEO POWER UNLEASHED</h5>
        <h1 className="ugc-title">Harness the Power of User-Generated Video</h1>
        <p className="ugc-description">
          As the world’s foremost provider of user-generated video content to advertisers, digital
          editorial publishers, social media & entertainment companies, we are equipped with a
          library of more than 100,000 brand-safe, viral and trending videos sourced by our in-house
          global search team. We also have a bespoke services arm that performs video discovery,
          clearance, and licensing around the globe.
        </p>
      </div>

      <div className="how-it-works-wrapper">
        <div>
          <img
            className="how-it-works-image"
            src={HowItWorksBg}
            alt="how-it-works-background"
          ></img>
        </div>

        <div className="how-it-works-container">
          <HowItWorksSection
            line
            title="It Works For Our Clients"
            description="We have licensed tens of thousands of clips to brands and advertisers, publishers, social media powerhouses and countless TV shows across the globe. Our videos have appeared in more than 4,000 commercials and 500+ episodes of linear TV"
          />
          <HowItWorksSection
            line
            title="It Works For Our Audiences"
            description="Authentic UGC is the most trustworthy content. 75% of people say “UGC makes content more authentic”"
          />
          <HowItWorksSection
            title="It Works For Us"
            description="UGC is core to the success of our own properties with 40K reader stories, 12K recipes and 100k Jokes. All of this content powers our 4 streaming channels that can be found across 25 global platforms. Our content is engaging our audience with 62 minutes daily watch time on average and our websites attract 42 million unique visitors a month"
          />
        </div>
      </div>
    </UgcContainer>
  );
}

export default Ugc;
